<template>
  <q-page padding>
    <PageHeader :backRoute="{ name: 'home' }" backBehavior="route">
      <template #title> Cadastro Facial </template>
      <template #actions>
        <span class="q-ml-sm text-h6 text-weight-bold text-brand-5">
          - {{ usuario ? usuario.name : "Selecione um Usuário" }}
        </span>
      </template>
    </PageHeader>
    <div
      class="row col-12 q-mt-md text-brand-5 text-weight-bold q-gutter-sm items-center"
    >
      <div class="col-md-2 col-xs-8">
        <div class="q-ml-sm text-brand-5 texto-inputs">Nome do Usuario</div>
        <q-select
          v-model="usuario"
          dense
          outlined
          class="select q-mt-sm q-mb-sm"
          label="Digite o nome para pesquisar"
          :options="usersList"
          option-label="name"
          option-value="id"
          use-input
          map-options
          @filter="filterFn"
        />
      </div>

      <div>
        <q-toggle
          class="texto-toggle"
          v-model="livesCheck"
          label="LivenessCheck"
        />
      </div>

      <!--<div class="col-md-2 col-xs-8">
        <div class="q-ml-sm text-brand-5 texto-inputs">Selecionar Camera</div>
       
        <q-select
          v-model="deviceSelected"
          dense
          outlined
          class="select q-mt-sm q-mb-sm"
          label="Digite o nome para pesquisar"
          :options="devicesList"
          option-label="label"
          
        />
      </div>-->
    </div>

    <div class="print-container">
      <q-icon
        name="verified"
        v-if="sendSucess"
        color="positive"
        class="q-mt-xl"
        size="200px"
      />

      <video v-if="esconderCaptura" class="faceCapture" autoplay></video>
      <q-btn
        v-if="esconderCaptura"
        :disable="!usuario"
        label="Capturar"
        class="q-mt-md q-ml-sm"
        color="secondary"
        icon="visibility"
        @click="screenShot"
      />

      <canvas
        v-show="!esconderCaptura && sendSucess != true"
        style="height: 100%; width: 50%"
        class="canvasFace q-mt-md"
      ></canvas>
      <div v-if="!esconderCaptura" class="row q-mt-md">
        <q-btn
          v-if="sendSucess != true"
          :disable="!usuario"
          label="Enviar"
          class="q-ml-sm"
          color="positive"
          icon="add"
          @click="EnviarFace"
        />
        <q-btn
          v-if="sendSucess != true"
          :disable="!usuario"
          label="Enviar em Lote"
          class="q-ml-sm"
          color="positive"
          icon="add"
          @click="EnviarFaceLote"
        />
        <q-btn
          :disable="!usuario"
          label="Tirar novamente"
          class="q-ml-sm"
          color="secondary"
          icon="refresh"
          @click="screenRepeat"
        />
      </div>
    </div>

    <span class="row justify-end">
      <q-btn
        :disable="faceList.length == 0"
        label="Limpar Fotos"
        class="q-ml-sm q-mt-md"
        color="negative"
        icon="clear"
        @click="faceList = []"
      />
    </span>

    <section class="q-mt-xl face-container-bottom grid-template-columns">
      <div v-for="(face, index) in faceList" :key="index">
        <img obje :src="face" alt="" />
      </div>
    </section>
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const time = ref();
    const usuario = ref(null);
    const devicesList = ref([]);
    const sendSucess = ref(false);
    const deviceSelected = ref("");
    const esconderCaptura = ref(true);
    const faceSend = ref(null);
    const faceList = ref([]);
    const livesCheck = ref(false);
    const contrains = ref({
      video: {
        width: {
          min: 1280,
          ideal: 1920,
          max: 1920,
        },
        height: {
          min: 720,
          ideal: 1080,
          max: 1080,
        },
      },
    });
    const usersList = ref([]);

    const getUserImage = async () => {
      const video = document.querySelector(".faceCapture");

      if (
        "mediaDevices" in navigator &&
        "getUserMedia" in navigator.mediaDevices
      ) {
        await navigator.mediaDevices
          .getUserMedia({
            ...contrains.value,
          })
          .then((stream) => {
            video.srcObject = stream;
            video.play();
          });
      }
    };

    const screenShot = async () => {
      const canvas = document.querySelector(".canvasFace");
      const video = document.querySelector(".faceCapture");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d").drawImage(video, 0, 0);
      canvas.src = canvas.toDataURL("image/webp");
      faceList.value.push(canvas.toDataURL("image/jpeg", 0.9));
      faceSend.value = canvas.toDataURL("image/jpeg", 0.9).slice(23);
      esconderCaptura.value = false;
    };

    const getUsers = async (val) => {
      try {
        let response = await store.dispatch("facialStore/getUsers", {
          search: val,
        });
        usersList.value = response.data.results.data;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar usuarios",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getDevices = async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();

      devicesList.value = devices.filter((value) => {
        if (value.label != "") {
          return { id: value.deviceId, label: value.label };
        }
      });
    };

    onMounted(getDevices);

    const screenRepeat = async () => {
      sendSucess.value = false;
      esconderCaptura.value = true;

      if (
        "mediaDevices" in navigator &&
        "getUserMedia" in navigator.mediaDevices
      ) {
        const stream = await navigator.mediaDevices.getUserMedia({
          ...contrains.value,
        });
        const video = document.querySelector(".faceCapture");
        video.srcObject = stream;

        video.play();
      }
    };

    const EnviarFace = async () => {
      try {
        const idFace = `${store.state.autenticacao.cliente[0]}${usuario.value.id}`;

        await store.dispatch("facialStore/cadastrarFacial", {
          id: idFace,
          base64_image: faceSend.value,
          livesCheck: livesCheck.value,
        });

        quasar.notify({
          message: "Rosto cadastrado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        sendSucess.value = true;
      } catch (error) {
        quasar.notify({
          message: "Erro a o cadastrar rosto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const EnviarFaceLote = async () => {
      try {
        let imagesArray = [];
        const idFace = `${store.state.autenticacao.cliente[0]}${usuario.value.id}`;

        faceList.value.forEach((e) => {
          imagesArray.push({ imageType: "frontal", imageData: e.slice(23) });
        });

        await store.dispatch("facialStore/cadastrarFacialLote", {
          id: idFace,
          imagesArray: imagesArray,
          livesCheck: livesCheck.value,
        });

        quasar.notify({
          message: "Cadastro em lote feito com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        sendSucess.value = true;
        faceList.value = [];
      } catch (error) {
        quasar.notify({
          message: "Erro a o cadastrar rosto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch([() => usuario.value], () => {
      getUserImage();
    });

    return {
      getUserImage,
      usuario,
      usersList,
      devicesList,
      deviceSelected,
      getUsers,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }
        usersList.value = [];
        time.value = setTimeout(() => {
          getUsers(val);
        }, 1000);

        setTimeout(() => {
          update();
        }, 1500);

        setTimeout(() => {
          update();
        }, 1000);
      },
      screenShot,
      esconderCaptura,
      screenRepeat,
      EnviarFace,
      sendSucess,
      livesCheck,
      faceList,
      EnviarFaceLote,
    };
  },
};
</script>

<style scoped>
.print-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

video {
  width: 50%;
  height: 100%;
}

.face-container-bottom {
  display: grid;
  margin-top: 100px;
  gap: 19px;
  justify-content: center;
}

.face-container-bottom img {
  width: 400px;
  height: 400px;
  object-fit: cover;
}

.grid-template-columns {
  grid-template-columns: 400px 400px 400px;
}
</style>
